import UserInfoTemp from 'components/UserInfoTemp/UserInfoTemp';

export default UserInfoTemp;
